module.exports = __webpack_public_path__ + "static/head_icon-eb6057b1e0ca4458efd32f71dd117d9d.jpg";